var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM15.9889 16.2569C18.3482 16.2569 20.2662 14.4053 20.2662 12.1291C20.2662 9.85207 18.3482 8 15.9889 8C13.63 8 11.7116 9.85207 11.7116 12.1291C11.7116 14.4053 13.63 16.2569 15.9889 16.2569ZM20.2143 18.634C19.4409 19.1029 18.6012 19.4354 17.7305 19.6269L20.1216 21.9352C20.6115 22.4071 20.6115 23.1734 20.1216 23.6457C19.6323 24.1181 18.8392 24.1181 18.3504 23.6457L15.9994 21.3774L13.6505 23.6457C13.4056 23.8817 13.0847 23.9998 12.7638 23.9998C12.4433 23.9998 12.1229 23.8817 11.878 23.6457C11.3887 23.1734 11.3887 22.4076 11.8775 21.9352L14.2689 19.6269C13.3982 19.4354 12.5585 19.1024 11.7851 18.634C11.1998 18.2778 11.024 17.5315 11.3928 16.966C11.7605 16.3998 12.5339 16.2293 13.1203 16.5855C14.8713 17.6488 17.127 17.649 18.8791 16.5855C19.4654 16.2293 20.2386 16.3998 20.6071 16.966C20.9759 17.531 20.7996 18.2778 20.2143 18.634Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9888 10.4199C16.9654 10.4199 17.7598 11.1865 17.7598 12.1292C17.7598 13.0712 16.9654 13.8382 15.9888 13.8382C15.0129 13.8382 14.2178 13.0712 14.2178 12.1292C14.2178 11.1865 15.0129 10.4199 15.9888 10.4199V10.4199Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.763c5ff6.svg";
export { ForwardRef as ReactComponent };